/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { SecurityHelper } from 'sarsaparilla';

import ModifyGroupSizeModal from '../../shared-components/registration/ModifyGroupSizeModal';
import { readRuleValue, getFirstDivision, getMaxMemberQuota } from '../utils/utilsNew';
import * as pActions from '../actions/permit';
import { modifyIssuanceGroupSize } from '../utils/issuance-utilsNew';
import { MIN_GROUP_SIZE_KEY_NAME } from '../constants';
import * as PROPS from '../props/permit';

const fetchMaxAvailableGroupSize = async (permit, issuance) => {
    const maxGroupSizeAvailableResponse = await axios.get(
        `/api/permits/${permit.id}/availability/${issuance.id}/maxgroupsize`,
        { headers: { Authorization: SecurityHelper.getAuthHeader() } }
    );
    return maxGroupSizeAvailableResponse.data.payload;
};

export function ModifyGroupSizeModalContainer({
    permit,
    issuance,
    updateIssuance,
    dispatch,
    ...props
}) {
    const [isModifyingGroupSize, setIsModifyingGroupSize] = useState(false);
    const permitRuleMaxGroupSize = getMaxMemberQuota({ permit, issuance });
    const permitRuleMinGroupSize =
        readRuleValue(
            MIN_GROUP_SIZE_KEY_NAME,
            permit?.rules,
            issuance.division_id || getFirstDivision(permit)
        ) || 0;
    const originalGroupSize = issuance?.group_info?.length || 0;

    const modifyGroupSize = useCallback(
        async (groupSize) => {
            const updatedIssuance = {
                ...modifyIssuanceGroupSize(issuance, groupSize),
                is_modify_quota: true,
            };
            setIsModifyingGroupSize(true);
            try {
                return await dispatch(pActions.updateIssuance(updatedIssuance));
            } finally {
                setIsModifyingGroupSize(false);
            }
        },
        [issuance, dispatch, updateIssuance, permit]
    );

    const handleFetchMaxAvailableGroupSize = useCallback(() => {
        return fetchMaxAvailableGroupSize(permit, issuance);
    }, [permit, issuance]);

    return (
        <ModifyGroupSizeModal
            {...props}
            isModifyingGroupSize={isModifyingGroupSize}
            originalGroupSize={originalGroupSize}
            permitRuleMaxGroupSize={permitRuleMaxGroupSize}
            permitRuleMinGroupSize={permitRuleMinGroupSize}
            modifyGroupSize={modifyGroupSize}
            fetchMaxAvailableGroupSize={handleFetchMaxAvailableGroupSize}
        />
    );
}

ModifyGroupSizeModalContainer.propTypes = {
    dispatch: PropTypes.func,
    modifyGroupSizeError: PropTypes.shape({}),
    permit: PROPS.PERMIT,
    issuance: PROPS.ISSUANCE,
    isOpen: PropTypes.bool,
    onSuccess: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    updateIssuance: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        modifyGroupSizeError: state.permit.update_issuance_error,
        issuance: state.permit.issuance,
        permit: state.permit.result,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModifyGroupSizeModalContainer);
